import Storage from './web/Storage'

const supportedInsertFileTypesDefault = [
  'png',
  'jpg',
  'jpeg'
]

export default class Platform {
  constructor({
    vectorFormat = 'svg',
    supportedInsertFileTypes = [],
    storage,
    clientId,
    clientSecret,
    features = {},
    platform = process.env.VUE_APP_PLATFORM
  }) {
    this.clientId = clientId
    this.clientSecret = clientSecret
    this.vectorFile = vectorFormat
    this.supportedInsertFileTypes = [
      ...supportedInsertFileTypesDefault,
      ...supportedInsertFileTypes
    ]
    this.storage = storage || new Storage()
    this.platform = platform

    // Features that are supported in each apps
    this.features = {
      vector: true,
      fillType: false,
      prototype: true,
      messages: false,
      downloadToDevice: false,
      localStorage: true,
      syncFromTool: false,
      ...features
    }

    this.log('Platform Created!')
  }

  // Init Script that runs in the index.html
  // This can be used if we need to add any extra platform dependent JS Script
  init() {
    console.log('Hi Developers!')
  }

  insertItem() { }

  getSelectedShapesCount() { }

  openURL(url) {
    console.log('Opening', url)
  }

  quit() {
    console.log('Quit')
  }

  showMessage(message) {
    console.log(message)
  }

  getSelectionCount() {
    console.log('Platform: getSelectionCount')
    return 0
  }

  syncSelection(uuid, token) {
    console.log('Platform: syncSelection', uuid, token)
  }

  fillColor(color) {
    console.log('Platform: fillColor', color)
  }

  fillBorderColor(color) {
    console.log('Platform: fillBorderColor', color)
  }

  addToDocumentColor (color) {
    console.log('Platform: addToDocumentColor', color)
  }

  log() {
    if (console && console.log) {
      console.log(...arguments)
    }
  }
}
